import React from 'react';
import { CheckIcon, RefreshCwIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
const rows = [{
  label: 'Hypertension Route — 6 Clinical Volumes',
  value: '$97 USD'
}, {
  label: '5 Exclusive Bonuses',
  value: '$150 USD'
}];
const guarantees = ['Instant access', 'One-time payment', 'Lifetime access', '7-day guarantee'];
export function Offer() {
  return <section id="offer" className="w-full bg-bone px-4 py-14 sm:px-6 sm:py-20" data-id="element-219" data-mp="3f4jsfzon6mtd">
      <div className="mx-auto w-full max-w-2xl" data-id="element-220" data-mp="3jv8irbol5dqx">
        <div className="text-center" data-id="element-221" data-mp="3jwjmjbi16li1">
          <p className="inline-flex items-center gap-2 rounded-full bg-blood px-3.5 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.16em] text-white" data-id="element-222" data-mp="3jxmfdoywyy0l">
            🏆 Special launch offer
          </p>
          <h2 className="mt-4 font-display text-[26px] font-extrabold leading-tight text-ink sm:text-4xl" data-id="element-223" data-mp="1pn823q2hb5x">
            If you purchased each resource separately, here’s what you’d pay
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-2xl bg-white shadow-card ring-1 ring-ink/10" data-id="element-224" data-mp="1flvmqajni67o">
          <div className="flex items-center justify-between gap-4 bg-cream px-4 py-3 sm:px-5" data-id="element-225" data-mp="1bka1o1wyqlme">
            <span className="text-[11px] font-extrabold uppercase tracking-[0.14em] text-graphite/70" data-id="element-226" data-mp="16lyvc15vmt8x">
              What you get
            </span>
            <span className="text-[11px] font-extrabold uppercase tracking-[0.14em] text-graphite/70" data-id="element-227" data-mp="23bg3qnw8uteb">
              Value
            </span>
          </div>
          {rows.map(row => <div key={row.label} className="flex items-start justify-between gap-4 border-t border-ink/[0.07] px-4 py-4 sm:px-5" data-id="element-228" data-mp="1uicukrsmt2ph">
              <span className="text-[14px] font-semibold leading-snug text-ink" data-id="element-229" data-mp="2n072ane5ytzg">
                {row.label}
              </span>
              <span className="shrink-0 text-[14px] font-bold text-graphite/70" data-id="element-230" data-mp="2i7nr1x2y8axt">
                {row.value}
              </span>
            </div>)}
          <div className="flex items-center justify-between gap-4 border-t border-ink/10 bg-ink px-4 py-4 sm:px-5" data-id="element-231" data-mp="3653jajkwz64y">
            <span className="text-[12px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-232" data-mp="2sc44ykwvbhyz">
              Total value
            </span>
            <span className="text-lg font-extrabold text-white line-through decoration-blood decoration-2" data-id="element-233" data-mp="2wcnzdgq247hf">
              $247 USD
            </span>
          </div>
        </div>

        <div className="mt-6 rounded-2xl bg-ink p-6 text-center sm:p-8" data-id="element-234" data-mp="2nfnfnndxmxkb">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.2em] text-white/60" data-id="element-235" data-mp="29f2u4jgmunn4">
            Today, you pay only
          </p>
          <p className="mt-2 font-display text-[56px] font-bold leading-none text-white sm:text-7xl" data-id="element-236" data-mp="2dhz9806ys1mb">
            $27<span className="ml-2 text-2xl sm:text-3xl" data-id="element-237" data-mp="7ktu0du7c56b">USD</span>
          </p>
          <p className="mx-auto mt-4 max-w-sm text-[13px] leading-relaxed text-white/70 sm:text-sm" data-id="element-238" data-mp="bo011np520du">
            One-time payment. No monthly fees. No renewals. No hidden costs.
          </p>

          <p className="mx-auto mt-4 inline-flex items-center gap-2 rounded-full bg-white/[0.08] px-3.5 py-2 text-[12px] font-semibold text-white/80" data-id="element-239" data-mp="1s6jw5kchroep">
            <RefreshCwIcon className="h-3.5 w-3.5 text-blood" aria-hidden="true" data-id="element-240" data-mp="215x5md0m8czf" />
            Currency conversion is automatic, based on your country
          </p>

          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-2" data-id="element-241" data-mp="2fwnyzphuvk4n">
            {guarantees.map(item => <li key={item} className="flex items-center gap-1.5 text-[12px] font-bold text-white/85" data-id="element-242" data-mp="2ov9cv7cduaz3">
                <CheckIcon className="h-3.5 w-3.5 text-blood" aria-hidden="true" data-id="element-243" data-mp="2jxg72fezrizc" />
                {item}
              </li>)}
          </ul>

          <div className="mt-7 flex justify-center" data-id="element-244" data-mp="pi5cvd3z41wb">
            <CtaButton label="I want Hypertension Route for $27 USD" variant="light" data-id="element-245" data-mp="pjorz0dw86wi" />
          </div>

          <div className="mt-8 border-t border-white/10 pt-7" data-id="element-246" data-mp="rw959jctli2y">
            <Countdown tone="dark" data-id="element-247" data-mp="vxmabr839h8t" />
          </div>

          <div className="mt-6" data-id="element-248" data-mp="w0gsfc3mqpz2">
            <ScarcityBar tone="dark" data-id="element-249" data-mp="10wyvm7jbag9a" />
          </div>
        </div>
      </div>
    </section>;
}